import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  // Данные по юнитам контрагента
  distributor_units: [],
  // Флаг запроса всех юнитов поставщика
  distributor_units_fetching: false,
  // Флаг обновления юнитов поставщика
  distributor_units_updating: false
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
